import React from 'react';

import { createClassName } from 'utils/createClassName';

import './adminPageHeadLayoutStyles.scss';

export const AdminPageHeadLayout: React.FC = (props) => {
  const { children } = props;

  const createElementClassName = createClassName('admin-page-head-layout');

  return <div className={createElementClassName('wrapper')}>{children}</div>;
};
